import { z } from "zod/v4";
import { flagsConfigSchema } from "../featureFlags";

const postHogSchema = z.object({
  apiHost: z.string(),
  uiHost: z.string(),
  publicKey: z.string(),
});

export const configSchema = z.object({
  name: z.string(),
  version: z.string().optional(),
  featureFlags: flagsConfigSchema,
  apiUrl: z.string(),
  loginUrl: z.string(),
  authressApplicationId: z.string(),
  postHog: postHogSchema.optional(),
});

export type Config = z.infer<typeof configSchema>;
